// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3ERcA","log":"ModalInventoryLogs_log__2CJzL","date":"ModalInventoryLogs_date__32LdK","userName":"ModalInventoryLogs_userName__3C-qZ"};